var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"number-card"}},[_c('div',{staticClass:"main"},[_c('span',{staticClass:"head-img"},[_c('img',{attrs:{"src":_vm.headImg,"alt":""}})]),_c('div',{staticClass:"text"},[_c('label',{staticClass:"number",style:(_vm.numberStyle)},[_vm._v(_vm._s(_vm.num))]),_c('label',{staticClass:"explain"},[_vm._v(_vm._s(_vm.exp))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }